// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var IconsJson = require("../../../../assets/icons.json");

var icons = IconsJson;

function IconV5(props) {
  var __className = props.className;
  var __cursorPointer = props.cursorPointer;
  var __size = props.size;
  var size = __size !== undefined ? __size : 16;
  var cursorPointer = __cursorPointer !== undefined ? __cursorPointer : false;
  var className = __className !== undefined ? __className : "";
  var cls = TailwindMerge.twMerge([
        "flex-none",
        cursorPointer ? "cursor-pointer" : "",
        className
      ]);
  var size$1 = size.toString();
  var def = icons[props.icon];
  if (def !== undefined) {
    return JsxRuntime.jsx("svg", {
                children: JsxRuntime.jsx("path", {
                      d: def.path
                    }),
                className: cls,
                role: "img",
                height: size$1,
                width: size$1,
                onClick: props.onClick,
                fill: "currentColor",
                viewBox: def.viewBox
              });
  } else {
    return null;
  }
}

var make = IconV5;

exports.icons = icons;
exports.make = make;
/* icons Not a pure module */
